import type { GeometryKey } from './keys';

export const ro: Record<GeometryKey, string> = {
  // 9 Experiments
  'experiment.angle-chase': 'Vânătoare de unghiuri',
  'experiment.triangle-lab': 'Laborator triunghiuri',
  'experiment.pythagoras': 'Pitagora',
  'experiment.similarity': 'Asemănare',
  'experiment.circle-theorems': 'Teoreme despre cerc',
  'experiment.area-lab': 'Laborator arii',
  'experiment.transformations': 'Transformări',
  'experiment.coordinate-geometry': 'Geometrie analitică',
  'experiment.constructions': 'Construcții',
  // Common controls
  'action.reset': 'Resetează',
  'action.randomise': 'Aleatorizează',
  'action.show-me': 'Arată-mi',
  'action.undo': 'Anulează',
  'action.eraser': 'Radieră',
  'panel.advanced': 'Avansat',
  'panel.mode': 'Mod',
  'panel.tool': 'Instrument',
  // Shared chrome — eyebrow + interaction hint
  'app.eyebrow': 'Geometrie · 2D',
  'hint.line1': 'Trage punctele colorate pentru a explora.',
  'hint.line2': 'Matematica trăiește în figură, nu în text.',
  // Coordinate-geometry additions
  'coord.panel.ratio-m': 'Raport m',
  'coord.panel.ratio-n': 'Raport n',
  'coord.panel.show-angles': 'Arată unghiurile',
  // Transformations — symmetry redesign
  'transform.symmetry.drag-hint': 'Trage axa de simetrie',
  'transform.symmetry.axis-found': 'Axă de simetrie ✓',
  'transform.symmetry.axes': 'Axe de simetrie',
  'transform.symmetry.rotation-order': 'Ordin de rotație',
  'transform.symmetry.spin': 'Rotește',
  // Constructions — tool options
  'construct.tool.compass': 'Compas',
  'construct.tool.straightedge': 'Riglă',
  'construct.tool.eraser': 'Radieră',
  // Shared badges
  'badge.parallel': '∥',
  'badge.perpendicular': '⊥',
  'badge.similar': '~',
  'badge.invalid': '✗',
  // Angle-chase specific
  'angle.mode.around-a-point': 'În jurul unui punct',
  'angle.mode.parallel-lines': 'Drepte paralele',
  'angle.mode.polygon-angles': 'Unghiuri în poligon',
  'angle.mode.double-transversal': 'Dublă transversală',
  'angle.panel.angles-on-line': 'Unghiuri pe o dreaptă',
  'angle.panel.show-angle-values': 'Afișează valorile unghiurilor',
  'angle.panel.snap-to-5': 'Fixează la 5°',
  'angle.panel.n-gon-sides': 'Laturi (n)',
  'angle.preset.straight-line': 'Unghi de 180°',
  'angle.preset.full-turn': 'Rotație completă',
  'angle.preset.z-angles': 'Unghiuri Z',
  'angle.preset.c-angles': 'Unghiuri C',
  'angle.preset.f-angles': 'Unghiuri F',
  'angle.preset.pentagon-fan': 'Evantai pentagon',
  'angle.preset.hexagon-turtle': 'Mers broască-țestoasă hexagon',
  'angle.preset.double-transversal': 'Dublă transversală',
  // Triangle-lab specific
  'triangle.mode.free-drag': 'Tragere liberă',
  'triangle.mode.inequality': 'Inegalitate',
  'triangle.mode.congruence': 'Congruență',
  'triangle.criterion.SSS': 'LLL',
  'triangle.criterion.SAS': 'LUL',
  'triangle.criterion.ASA': 'ULU',
  'triangle.criterion.AAS': 'UUL',
  'triangle.criterion.SSA': 'LLU',
  'triangle.panel.show-measurements': 'Afișează măsurătorile',
  'triangle.panel.center-centroid': 'Centru de greutate',
  'triangle.panel.center-circumcenter': 'Centrul cercului circumscris',
  'triangle.panel.center-incenter': 'Centrul cercului inscris',
  'triangle.panel.center-orthocenter': 'Ortocentru',
  'triangle.preset.equilateral': 'Echilateral',
  'triangle.preset.isosceles-right': 'Isoscel dreptunghic',
  'triangle.preset.scalene-obtuse': 'Scalén obtuz',
  'triangle.preset.euler-tour': 'Dreapta lui Euler',
  'triangle.preset.ssa-two': 'LLU: două soluții',
  'triangle.criterion': 'Criteriu',
  // Pythagoras specific
  'pythagoras.mode.squares': 'Pătrate',
  'pythagoras.mode.converse': 'Reciprocă',
  'pythagoras.mode.triples': 'Triple pitagoreice',
  'pythagoras.mode.shapes': 'Figuri',
  'pythagoras.panel.show-areas': 'Afișează ariile',
  'pythagoras.panel.shape': 'Figură',
  'pythagoras.panel.scrubber': 'Scrubber demonstrație',
  'pythagoras.shape.square': 'Pătrat',
  'pythagoras.shape.semicircle': 'Semicerc',
  'pythagoras.shape.equilateral': 'Triunghi echilateral',
  'pythagoras.preset.3-4-5': '3–4–5',
  'pythagoras.preset.5-12-13': '5–12–13',
  'pythagoras.preset.1-1-sqrt2': '1–1–√2',
  'pythagoras.preset.8-15-17': '8–15–17',
  'pythagoras.preset.almost-right-4-5-6': 'Aproape dreptunghic (4–5–6)',
  // Similarity specific
  'similarity.mode.dilation': 'Dilatație',
  'similarity.mode.intercept': 'Teorema firelor paralele',
  'similarity.mode.similar-triangles': 'Triunghiuri asemenea',
  'similarity.panel.k': 'Factor de scară k',
  'similarity.panel.show-rays': 'Arată raze',
  'similarity.panel.show-area-grid': 'Arată grila de arii',
  'similarity.preset.midsegment-half': 'Linie mijlocie (k=½)',
  'similarity.preset.double-k-2': 'Dublare (k=2)',
  'similarity.preset.inversion-k-minus-1': 'Inversie (k=−1)',
  'similarity.preset.aa-detective': 'Detective AA',
  // Circle-theorems specific
  'circle.mode.inscribed': 'Unghi inscris',
  'circle.mode.tangent': 'Tangentă',
  'circle.mode.cyclic-quad': 'Patrulater inscriptibil',
  'circle.mode.alternate-segment': 'Segment altern',
  'circle.mode.power-of-point': 'Puterea unui punct',
  'circle.panel.show-central-angle': 'Arată unghiul central',
  'circle.panel.snap-to-diameter': 'Fixează pe diametru',
  'circle.preset.thales': 'Thales (diametru)',
  'circle.preset.minor-arc': 'Arc mic',
  'circle.preset.crossed-chords': 'Coarde încrucișate',
  'circle.preset.tangent-secant': 'Tangentă–secantă',
  // Area-lab specific
  'area.panel.shape': 'Formă',
  'area.panel.shear': 'Forfecare',
  'area.panel.sectors': 'Sectoare (n)',
  'area.panel.polygon-n': 'Laturi (n)',
  'area.panel.scrubber': 'Scrubber derivare',
  'area.panel.show-grid': 'Arată grila',
  'area.shape.parallelogram': 'Paralelogram',
  'area.shape.triangle': 'Triunghi',
  'area.shape.trapezoid': 'Trapez',
  'area.shape.circle': 'Cerc',
  'area.shape.regular-polygon': 'Poligon regulat',
  'area.shape.composite': 'Compus (formă L)',
  'area.shape.heron': 'Verificare Heron',
  'area.preset.parallelogram': 'Paralelogram (6×4)',
  'area.preset.triangle': 'Triunghi (6×4)',
  'area.preset.trapezoid': 'Trapez (3–5, h=4)',
  'area.preset.circle': 'Cerc (r=4)',
  'area.preset.hexagon-apothem': 'Apotemă hexagon',
  'area.preset.l-shape': 'Formă L compusă',
  'area.preset.heron-check': 'Verificare Heron (5–6–7)',
  // Transformations specific
  'transform.mode.transform': 'Transformare',
  'transform.mode.symmetry': 'Simetrie',
  'transform.mode.composition': 'Compoziție',
  'transform.mode.tessellation': 'Mozaicare',
  'transform.picker.translate': 'Translație',
  'transform.picker.rotate': 'Rotație',
  'transform.picker.reflect': 'Reflexie',
  'transform.picker.dilate': 'Dilatație',
  'transform.panel.transform': 'Transformare',
  'transform.panel.figure': 'Figură',
  'transform.panel.tile': 'Placă',
  'transform.panel.dilate-k': 'Factor de scară k',
  'transform.tile.square': 'Pătrat',
  'transform.tile.hexagon': 'Hexagon',
  'transform.tile.triangle': 'Triunghi',
  'transform.tile.escher-square': 'Pătrat Escher',
  'transform.preset.quarter-turn': 'Sfert de rotație',
  'transform.preset.mirror-flip': 'Reflexie în oglindă',
  'transform.preset.parallel-mirrors': 'Oglinzi paralele',
  'transform.preset.crossing-mirrors': 'Oglinzi încrucișate',
  'transform.preset.hexagon-tiling': 'Mozaicare hexagonală',
  // Coordinate-geometry specific
  'coord.mode.segment': 'Segment',
  'coord.mode.parallel-perpendicular': 'Paralele și perpendiculare',
  'coord.mode.section': 'Formula secțiunii',
  'coord.mode.shoelace': 'Aria prin șiretar',
  'coord.mode.locus': 'Locul geometric (bisectoare)',
  'coord.panel.show-rise-run': 'Arată triunghiul ridică/rulează',
  'coord.panel.ratio-mn': 'Raport m : n',
  'coord.preset.3-4-5-segment': 'Segment 3–4–5',
  'coord.preset.perpendicular-pair': 'Pereche perpendiculară',
  'coord.preset.section-2-1': 'Secțiune 2 : 1',
  'coord.preset.lattice-pentagon': 'Pentagon pe rețea',
  // Constructions — target labels
  'construct.target.perpendicular-bisector': 'Mediatoare',
  'construct.target.angle-bisector': 'Bisectoare',
  'construct.target.copy-segment': 'Copiază segment',
  'construct.target.copy-angle': 'Copiază unghi',
  'construct.target.perpendicular-at-point': 'Perpendiculară la punct',
  'construct.target.perpendicular-from-point': 'Perpendiculară din punct',
  'construct.target.inscribed-triangle': 'Triunghi inscris',
  'construct.target.inscribed-square': 'Pătrat inscris',
  'construct.target.inscribed-hexagon': 'Hexagon inscris',
  'construct.target.tangent-from-point': 'Tangentă din punct',
  'construct.target.incircle': 'Cerc inscris',
  'construct.target.circumcircle': 'Cerc circumscris',
  'construct.target.angle-60': 'Unghi 60°',
  'construct.target.angle-30': 'Unghi 30°',
  'construct.target.angle-45': 'Unghi 45°',
  // Constructions — panel keys
  'construct.panel.target': 'Construcție',
  'construct.panel.show-ghost': 'Arată obiectivul',
  // Constructions — readout keys
  'construct.readout.goal-met': 'Construcție completă',
  'construct.readout.working': 'În lucru…',
  // Constructions — scripted step captions
  'perpBisector.arc1': 'Arc din A',
  'perpBisector.arc2': 'Arc din B',
  'perpBisector.line': 'Unește intersecțiile',
  'angleBisector.arcFromVertex': 'Arc din vârf',
  'angleBisector.arc2': 'Arc din brațul A',
  'angleBisector.arc3': 'Arc din brațul B',
  'angleBisector.line': 'Trasează bisectoarea',
  'copySegment.arc': 'Compas cu lungimea segmentului',
  'copyAngle.arc1': 'Arc la noul vârf',
  'copyAngle.arc2': 'Copiază coarda — latura apropiată',
  'copyAngle.arc3': 'Copiază coarda — latura îndepărtată',
  'copyAngle.line': 'Trasează raza unghiului copiat',
  'perpAtPoint.arc1': 'Arc centrat în P',
  'perpAtPoint.arc2': 'Arc mare din piciorul stâng',
  'perpAtPoint.arc3': 'Arc mare din piciorul drept',
  'perpAtPoint.line': 'Unește intersecțiile',
  'perpFromPoint.arc1': 'Arc din punctul exterior',
  'perpFromPoint.arc2': 'Arc mare din piciorul stâng',
  'perpFromPoint.arc3': 'Arc mare din piciorul drept',
  'perpFromPoint.line': 'Unește intersecțiile',
  'inscribedHex.s1': 'Pasul 1 — vârf următor',
  'inscribedHex.s2': 'Pasul 2 — vârf următor',
  'inscribedHex.s3': 'Pasul 3 — vârf următor',
  'inscribedHex.s4': 'Pasul 4 — vârf următor',
  'inscribedHex.s5': 'Pasul 5 — vârf următor',
  'inscribedHex.side1': 'Trasează latura',
  'inscribedHex.side2': 'Trasează latura',
  'inscribedTri.s1': 'Arc — primul vârf',
  'inscribedTri.s2': 'Arc — al doilea vârf',
  'inscribedTri.s3': 'Arc — al treilea vârf',
  'inscribedTri.side1': 'Latura 1',
  'inscribedTri.side2': 'Latura 2',
  'inscribedTri.side3': 'Latura 3',
  'inscribedSquare.s1': 'Arc din P₀',
  'inscribedSquare.s2': 'Arc din antipod',
  'inscribedSquare.diam': 'Diametru perpendicular',
  'inscribedSquare.side1': 'Latura 1',
  'inscribedSquare.side2': 'Latura 2',
  'tangent.thalesCircle': 'Cerc Thales',
  'tangent.line1': 'Prima tangentă',
  'tangent.line2': 'A doua tangentă',
  'incircle.arcA': 'Arc la vârful A',
  'incircle.arc2': 'Arc bisectoare 2',
  'incircle.arc3': 'Arc bisectoare 3',
  'incircle.bisA': 'Bisectoarea la A',
  'incircle.arcB': 'Arc la vârful B',
  'incircle.arc6': 'Arc bisectoare 6',
  'incircle.arc7': 'Arc bisectoare 7',
  'incircle.bisB': 'Bisectoarea la B',
  'incircle.footArc': 'Arc pentru picior',
  'incircle.perpArc1': 'Arc perpendicular 1',
  'incircle.perpArc2': 'Arc perpendicular 2',
  'incircle.perpLine': 'Linie perpendiculară',
  'incircle.draw': 'Trasează cercul inscris',
  'circumcircle.arcA1': 'Arc A (1)',
  'circumcircle.arcA2': 'Arc A (2)',
  'circumcircle.bisAB': 'Mediator AB',
  'circumcircle.arcC1': 'Arc C (1)',
  'circumcircle.arcC2': 'Arc C (2)',
  'circumcircle.bisAC': 'Mediator AC',
  'circumcircle.draw': 'Trasează cercul circumscris',
  'angle60.arc1': 'Arc la origine',
  'angle60.arc2': 'Arc la Q',
  'angle60.line': 'Trasează raza la 60°',
  'angle30.arc1': 'Arc la origine',
  'angle30.arc2': 'Arc la Q',
  'angle30.line60': 'Trasează linia la 60°',
  'angle30.bisArc1': 'Arc bisectoare la origine',
  'angle30.bisArc2': 'Arc bisectoare 2',
  'angle30.bisArc3': 'Arc bisectoare 3',
  'angle30.line': 'Trasează raza la 30°',
  'angle45.perpArc1': 'Arc la origine',
  'angle45.perpArc2': 'Arc — picior apropiat',
  'angle45.perpArc3': 'Arc — picior îndepărtat',
  'angle45.line90': 'Trasează linia la 90°',
  'angle45.bisArc1': 'Arc bisectoare la origine',
  'angle45.bisArc2': 'Arc bisectoare 2',
  'angle45.bisArc3': 'Arc bisectoare 3',
  'angle45.line': 'Trasează raza la 45°',
  // Per-experiment help legend lines
  'help.angle-chase.1': 'Trage punctele colorate pentru a deschide sau închide unghiurile.',
  'help.angle-chase.2':
    'Fiecare arc arată unghiul la acel vârf; bilele egale marchează unghiuri egale.',
  'help.angle-chase.3':
    'Săgețile paralele marchează raze paralele; afișajul dovedește suma unghiurilor.',
  'help.triangle-lab.1': 'Trage cele trei vârfuri colorate pentru a remodela triunghiul.',
  'help.triangle-lab.2':
    'Bilele de pe laturi marchează laturi egale; fiecare arc marchează un unghi interior.',
  'help.triangle-lab.3': 'Punctul colorat este centrul ales; afișajul listează măsurătorile.',
  'help.pythagoras.1': 'Trage vârfurile colorate pentru a schimba catetele a și b.',
  'help.pythagoras.2': 'Un pătrat sau o figură stă pe fiecare latură, cu aria scrisă în interior.',
  'help.pythagoras.3':
    'Afișajul arată a² + b² = c²: cele două arii mai mici se adună la cea mai mare.',
  'help.similarity.1': 'Trage punctele colorate; centrul de dilatație este punctul colorat.',
  'help.similarity.2': 'Razele din centru mapează pre-imaginea punctată la imaginea solidă.',
  'help.similarity.3':
    'Factorul de scară k indică cu cât este mai mare imaginea; aria crește cu k².',
  'help.circle-theorems.1': 'Trage punctele colorate pe cerc.',
  'help.circle-theorems.2':
    'Arcul marchează unghiul inscris; punctul central marchează unghiul la centru.',
  'help.circle-theorems.3': 'Afișajul dovedește teorema cercului pentru modul curent.',
  'help.area-lab.1':
    'Alege o figură, apoi trage glisoarele pentru a-i schimba dimensiunea sau forfecarea.',
  'help.area-lab.2': 'Aria este scrisă pe figură; forfecarea menține aria aceeași.',
  'help.area-lab.3': 'Glisorul de derivare rearanjează figura într-un dreptunghi cu arie egală.',
  'help.transformations.1': 'Figura punctată este pre-imaginea; figura colorată este imaginea.',
  'help.transformations.2':
    'La Simetrie, trage axa de simetrie — ea luminează pe o axă de simetrie adevărată.',
  'help.transformations.3':
    'Rotirea dezvăluie simetria de rotație; afișajul listează axele și ordinul.',
  'help.coordinate-geometry.1': 'Trage punctele colorate A și B pe rețea.',
  'help.coordinate-geometry.2':
    'Triunghiul punctat arată creșterea și deplasarea; arcul arată unghiul.',
  'help.coordinate-geometry.3': 'Afișajul oferă distanțe, pante și arii exacte.',
  'help.constructions.1': 'Alege un instrument (compas sau riglă) și o construcție țintă.',
  'help.constructions.2':
    'Figura punctată palidă este obiectivul; punctele de ancorare arată unde poți apăsa.',
  'help.constructions.3':
    'Când desenul tău corespunde obiectivului, acesta luminează și ecusoanele confirmă.',
};
